import { InternalTransferTemplateDetailModelDto } from '@treasury/api/channel';
import { Nullable } from '@treasury/utils';

export const nullTransferTemplateDetails: Nullable<InternalTransferTemplateDetailModelDto> = {
    totalTransferAmount: 0,
    numberOfApprovalsNeeded: 0,
    id: 0,
    updatedDate: '',
};
